import React from 'react'
import Box from '@mui/material/Box'

function UserNavLabel (props) {
  return <Box className='user-nav__label'>{props.labelText}</Box>
}

export default UserNavLabel
